export default (ref) => {
  if (!ref.teleport) return;

  const target = document.querySelector("[data-teleport-target]");

  const nonTeleportedElements = ref.teleport.filter(
    (el) => !el.dataset.teleported,
  );

  nonTeleportedElements.forEach((el) => {
    el.dataset.teleported = "true";
    el.classList.remove("opacity-0");
    target.append(el);

    const { addClassAfterTeleport } = el.dataset;
    if (addClassAfterTeleport) {
      setTimeout(() => {
        el.classList.add(...addClassAfterTeleport.split(" "));
      });
    }
  });

  return () => {
    const teleportedElements = ref.teleport.filter(
      (el) => el.dataset.teleported,
    );

    teleportedElements.forEach((el) => {
      el.style.transition = "opacity 300ms";
      el.style.opacity = "0";

      setTimeout(() => {
        el.remove();
      }, 300);
    });
  };
};
